import {FC} from 'react'
import {Building2, CheckCheck, RotateCcw, SlidersHorizontal, X} from 'lucide-react'

type Props = {
  company: any
  scopeLabel: string
  itemLabel: string
  totalCount: number
  activeCount: number
  loading: boolean
  onChange: (selectAll: boolean) => void
  onClose: () => void
}

const companyInitials = (name = '') =>
  name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase() || 'EM'

const CompanyBulkAccessModal: FC<Props> = ({
  company,
  scopeLabel,
  itemLabel,
  totalCount,
  activeCount,
  loading,
  onChange,
  onClose,
}) => {
  const coverage = totalCount ? Math.round((activeCount / totalCount) * 100) : 0

  return (
    <div className='ua-bulk-modal ua-user-bulk-modal'>
      <header className='ua-bulk-modal__header'>
        <span className='ua-section__heading-icon'>
          <Building2 size={19} />
        </span>
        <div>
          <small>Ação por empresa</small>
          <h3>Gerenciar todos os acessos</h3>
        </div>
        <button
          type='button'
          className='ua-icon-button'
          aria-label='Fechar'
          disabled={loading}
          onClick={onClose}
        >
          <X size={16} />
        </button>
      </header>

      <div className='ua-user-bulk-modal__profile'>
        <span className='ua-avatar'>{companyInitials(company?.name)}</span>
        <span className='ua-user-cell__copy'>
          <strong>{company?.name}</strong>
          <small>{scopeLabel}</small>
        </span>
        <span className='ua-badge'>{activeCount} ativos</span>
      </div>

      <div className='ua-user-bulk-modal__coverage'>
        <div>
          <span>Cobertura atual</span>
          <strong>{coverage}%</strong>
        </div>
        <span className='ua-user-bulk-modal__track'>
          <span style={{width: `${coverage}%`}} />
        </span>
      </div>

      <div className='ua-bulk-modal__body'>
        <p>Escolha uma ação para todos os {itemLabel} desta empresa.</p>
        <button
          type='button'
          className='ua-bulk-action is-positive'
          disabled={loading || activeCount === totalCount}
          onClick={() => onChange(true)}
        >
          <span>{loading ? <span className='ua-spinner' /> : <CheckCheck size={18} />}</span>
          <span>
            <strong>Conceder todos</strong>
            <small>
              Ativa os {totalCount} {itemLabel} disponíveis.
            </small>
          </span>
        </button>
        <button
          type='button'
          className='ua-bulk-action is-negative'
          disabled={loading || activeCount === 0}
          onClick={() => onChange(false)}
        >
          <span>{loading ? <span className='ua-spinner' /> : <RotateCcw size={18} />}</span>
          <span>
            <strong>Remover todos</strong>
            <small>Retira todos os {itemLabel} concedidos.</small>
          </span>
        </button>
      </div>

      <div className='ua-user-bulk-modal__note'>
        <SlidersHorizontal size={13} />A alteração considera todos os itens disponíveis, inclusive
        os ocultos pelos filtros.
      </div>
    </div>
  )
}

export default CompanyBulkAccessModal
